import {Injectable} from '@angular/core'
import {HttpService} from './_.http-mock'
import {Observable} from 'rxjs'
import {QuestionModel} from '../model/question.model'

@Injectable()
export class QuestionHttp {

  constructor(protected http: HttpService) {
  }

  add(question: QuestionModel): Observable<QuestionModel> {
    return this.http.put(`question`, question)
  }

  update(question: QuestionModel): Observable<QuestionModel> {
    return this.http.post(`question/${question.id}`, question)
  }

  move(id: string, index: number): Observable<QuestionModel> {
    return this.http.post(`question/${id}`, {id, index})
  }

  remove(questionId: string): Observable<any> {
    return this.http.delete(`question/${questionId}`)
  }
}
